module.exports = __webpack_public_path__ + "img/html.75fed241.png";